module.exports = __webpack_public_path__ + "static/media/Asset 2.22ddb625.svg";